import React from 'react';
import { motion } from 'framer-motion';
import './GetTheGame.css';

const GetTheGame = () => {
  return (
    <section className="get-game" id="get-the-game" data-aos="fade-up">
      <div className="container">
        <h2 className="get-game__title" data-aos="fade-down" data-aos-delay="200">
          Get the Game
        </h2>
        <p className="get-game__description" data-aos="fade-up" data-aos-delay="300">
          Ready to test your skills? CyberLingo is available as a physical 
          card game and on digital platforms. Choose your preferred way to play!
        </p>
        <div className="get-game__buttons" data-aos="zoom-in" data-aos-delay="400">
          <motion.a 
            href="https://wa.link/rv0sz4" 
            className="get-game__button get-game__button--primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Purchase Now
          </motion.a>
          <motion.a 
            href="#" 
            className="get-game__button get-game__button--store"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="material-icons">shop</span>
            <span>Play Store</span>
          </motion.a>
          <motion.a 
            href="#" 
            className="get-game__button get-game__button--store"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="material-icons">apple</span>
            <span>App Store</span>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default GetTheGame;